module.exports = __webpack_public_path__ + "static/media/meeting-custom-date-active.b8c6dcee.svg";